import { DAY_FORMAT } from "../consts";

export function dateFormat(date: Date) {
  return DAY_FORMAT.format(date);
}
